(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strwky-scroll-commerce"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRoot = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const story = root.querySelector('[data-story]');
      const video = root.querySelector('.strwky-commerce__scroll-video');
      const chapters = Array.from(root.querySelectorAll('[data-stage-time]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let duration = 5;
      let storyFrame = 0;
      let seekFrame = 0;
      let videoReady = false;
      let seekInProgress = false;
      let pendingTime = 0;
      let seekWatchdog = 0;

      const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

      const applyPendingTime = () => {
        seekFrame = 0;
        if (!videoReady || seekInProgress) return;

        const frameEnd = Math.max(0, duration - (1 / 30));
        const nextTime = clamp(pendingTime, 0, frameEnd);
        if (Math.abs(video.currentTime - nextTime) <= (1 / 120)) return;

        seekInProgress = true;
        try {
          video.currentTime = nextTime;
          window.clearTimeout(seekWatchdog);
          seekWatchdog = window.setTimeout(() => {
            seekInProgress = false;
            requestVideoTime(pendingTime);
          }, 600);
        } catch (error) {
          seekInProgress = false;
        }
      };

      const requestVideoTime = (time) => {
        pendingTime = time;
        if (!seekFrame) seekFrame = window.requestAnimationFrame(applyPendingTime);
      };

      const updateStory = () => {
        storyFrame = 0;
        if (!story || !video || chapters.length === 0) return;

        const rect = story.getBoundingClientRect();
        const distance = Math.max(1, story.offsetHeight - window.innerHeight);
        const scrollOffset = clamp(-rect.top, 0, distance);
        let active = chapters.length - 1;

        for (let index = 0; index < chapters.length - 1; index += 1) {
          if (scrollOffset < chapters[index + 1].offsetTop) {
            active = index;
            break;
          }
        }

        const startOffset = chapters[active].offsetTop;
        const endOffset = active === chapters.length - 1
          ? distance
          : Math.min(distance, chapters[active + 1].offsetTop);
        const localProgress = endOffset > startOffset
          ? clamp((scrollOffset - startOffset) / (endOffset - startOffset), 0, 1)
          : 0;
        const start = Number(chapters[active].dataset.stageTime || 0);
        const end = active === chapters.length - 1 ? start : Number(chapters[active + 1].dataset.stageTime || 1);
        const stageProgress = reduceMotion ? start : start + (end - start) * localProgress;
        const targetTime = clamp(stageProgress * duration, 0, Math.max(0, duration - (1 / 30)));

        requestVideoTime(targetTime);
      };

      const requestStoryUpdate = () => {
        if (!storyFrame) storyFrame = window.requestAnimationFrame(updateStory);
      };

      if (video) {
        const markVideoReady = () => {
          duration = Number.isFinite(video.duration) && video.duration > 0 ? video.duration : 5;
          videoReady = true;
          root.classList.toggle('strwky-commerce--screen-fallback', video.currentSrc.toLowerCase().includes('.mp4'));
          updateStory();
        };

        const primeVideo = () => {
          markVideoReady();

          try {
            if (video.readyState >= 1 && video.currentTime === 0) video.currentTime = 0.001;
          } catch (error) {
            // The queued scroll seek will retry as soon as WebKit permits it.
          }

          let playAttempt;
          try {
            playAttempt = video.play();
          } catch (error) {
            playAttempt = null;
          }

          if (playAttempt?.then) {
            playAttempt
              .then(() => video.pause())
              .catch(() => {});
          }

        };

        const useMp4Fallback = () => {
          const mp4Url = video.dataset.mp4Url;
          if (!mp4Url || video.currentSrc.toLowerCase().includes('.mp4')) {
            markVideoReady();
            return;
          }

          videoReady = false;
          seekInProgress = false;
          window.clearTimeout(seekWatchdog);
          root.classList.add('strwky-commerce--screen-fallback');
          video.src = mp4Url;
          video.load();
        };

        video.addEventListener('seeked', () => {
          window.clearTimeout(seekWatchdog);
          seekInProgress = false;
          if (Math.abs(video.currentTime - pendingTime) > (1 / 120)) requestVideoTime(pendingTime);
        });

        video.addEventListener('loadedmetadata', primeVideo);
        video.addEventListener('loadeddata', markVideoReady);
        video.addEventListener('canplay', markVideoReady);
        video.addEventListener('error', useMp4Fallback);

        if (video.readyState >= 1) {
          primeVideo();
        } else {
          video.load();
        }

        window.addEventListener('scroll', requestStoryUpdate, { passive: true });
        window.addEventListener('resize', requestStoryUpdate);

        root.addEventListener('strwky:destroy', () => {
          window.removeEventListener('scroll', requestStoryUpdate);
          window.removeEventListener('resize', requestStoryUpdate);
          if (storyFrame) window.cancelAnimationFrame(storyFrame);
          if (seekFrame) window.cancelAnimationFrame(seekFrame);
          window.clearTimeout(seekWatchdog);
        }, { once: true });
      }

      const cards = Array.from(root.querySelectorAll('[data-product-card]'));
      const countNode = root.querySelector('[data-order-count]');
      const priceNode = root.querySelector('[data-order-price]');
      const shippingNode = root.querySelector('[data-shipping-copy]');
      const addButton = root.querySelector('[data-add-button]');
      const statusNode = root.querySelector('[data-cart-status]');
      const orderNode = root.querySelector('.strwky-commerce__order');
      const freeShippingQuantity = Number(root.dataset.freeShippingQuantity || 4);
      const locale = root.dataset.locale || 'nl-NL';
      const currency = root.dataset.currency || 'EUR';
      const variantIds = new Set(cards.map((card) => Number(card.dataset.variantId)));
      let existingCart = { quantity: 0, originalCents: 0, finalCents: 0 };
      let reminderAcknowledged = false;

      const formatMoney = (cents) => new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(cents / 100);

      const getQuantity = (card) => Number(card.querySelector('[data-quantity]')?.value || card.querySelector('[data-quantity]')?.textContent || 0);
      const strwkyCart = (cart) => cart.items.reduce((summary, line) => {
        if (!variantIds.has(Number(line.variant_id))) return summary;
        summary.quantity += line.quantity;
        summary.originalCents += line.original_line_price;
        summary.finalCents += line.final_line_price;
        return summary;
      }, { quantity: 0, originalCents: 0, finalCents: 0 });
      const offerCents = (quantity, cents) => {
        if (quantity <= 0) return 0;
        const freeItems = Math.min(2, Math.max(0, quantity - 6));
        return cents - (Math.round(cents / quantity) * freeItems);
      };
      const offerBanner = (quantity, existingQuantity) => {
        let headline = 'Gratis verzending vanaf 4 STRWKY’s.';
        let support = '';
        if (quantity === 1) headline = 'Nog 3 STRWKY’s erbij en we verzenden gratis.';
        else if (quantity === 2) headline = 'Je bent op de helft! Nog 2 voor gratis verzending.';
        else if (quantity === 3) headline = 'Nog maar 1 erbij en je verzending is gratis!';
        else if (quantity === 4) {
          headline = 'Je verzending is gratis — je bespaart €3,49!';
          support = 'Koop 6, krijg 8 — nog eens €13,98 voordeel.';
        } else if (quantity === 5) {
          headline = 'Je verzending is gratis — je bespaart €3,49!';
          support = 'Nog 1 erbij voor 2 STRWKY’s cadeau — €13,98 extra voordeel.';
        } else if (quantity === 6) {
          headline = 'Kies nu je 2 gratis STRWKY’s met de +.';
          support = '€13,98 cadeau én gratis verzending.';
        } else if (quantity === 7) {
          headline = 'Kies nog 1 gratis STRWKY met de +.';
          support = 'Dan is je voordeel compleet!';
        } else if (quantity === 8) {
          headline = '8 STRWKY’s gekozen, je betaalt er 6!';
          support = 'Je bespaart €17,47: 2 cadeau én gratis verzending.';
        } else if (quantity > 8) {
          headline = `${quantity} STRWKY’s gekozen, je betaalt er ${quantity - 2}!`;
          support = '2 cadeau én gratis verzending.';
        }
        if (existingQuantity > 0) support += `${support ? ' ' : ''}Je winkelwagen bevat al ${existingQuantity} STRWKY’${existingQuantity === 1 ? '' : 's'}.`;
        return `<strong class="strwky-commerce__offer-headline">${headline}</strong>${support ? `<span class="strwky-commerce__offer-support">${support}</span>` : ''}`;
      };

      const updateOrder = () => {
        const totals = cards.reduce((summary, card) => {
          const quantity = getQuantity(card);
          return {
            quantity: summary.quantity + quantity,
            cents: summary.cents + quantity * Number(card.dataset.price || 0),
          };
        }, { quantity: 0, cents: 0 });

        if (countNode) {
          if (totals.quantity === 0) {
            countNode.textContent = root.dataset.countEmpty;
          } else {
            const noun = totals.quantity === 1 ? root.dataset.countSingular : root.dataset.countPlural;
            countNode.textContent = `${totals.quantity} ${noun}`;
          }
        }
        const offerQuantity = totals.quantity + existingCart.quantity;
        const extraCents = offerCents(offerQuantity, totals.cents + existingCart.originalCents) - offerCents(existingCart.quantity, existingCart.originalCents);
        if (priceNode) priceNode.textContent = totals.quantity === 0 ? '' : `${existingCart.quantity > 0 ? 'Extra bedrag ' : ''}${formatMoney(extraCents)}`;
        if (shippingNode) shippingNode.innerHTML = offerBanner(offerQuantity, existingCart.quantity);
        orderNode?.classList.toggle('strwky-commerce__order--empty', totals.quantity === 0);
        if (addButton) {
          addButton.disabled = totals.quantity === 0;
          addButton.textContent = totals.quantity === 0
            ? 'Kies een kleur'
            : `Voeg ${totals.quantity} ${totals.quantity === 1 ? 'STRWKY' : 'STRWKY’s'} toe aan winkelmandje`;
        }
      };

      cards.forEach((card) => {
        card.addEventListener('click', (event) => {
          const button = event.target.closest('[data-action]');
          if (!button || button.disabled) return;
          const output = card.querySelector('[data-quantity]');
          const direction = button.dataset.action === 'plus' ? 1 : -1;
          const next = clamp(getQuantity(card) + direction, 0, 12);
          reminderAcknowledged = false;
          output.value = String(next);
          output.textContent = String(next);
          if (statusNode) statusNode.textContent = '';
          updateOrder();
        });
      });

      const loadCartProgress = async () => {
        const routeRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${routeRoot}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        existingCart = strwkyCart(await response.json());
        updateOrder();
      };

      addButton?.addEventListener('click', async () => {
        const items = cards
          .map((card) => ({ id: Number(card.dataset.variantId), quantity: getQuantity(card) }))
          .filter((item) => item.id && item.quantity > 0);

        if (items.length === 0) return;
        const selectedQuantity = items.reduce((total, item) => total + item.quantity, 0);
        const offerQuantity = selectedQuantity + existingCart.quantity;
        if ((offerQuantity === 6 || offerQuantity === 7) && !reminderAcknowledged) {
          reminderAcknowledged = true;
          if (statusNode) statusNode.textContent = `Kies nog ${8 - offerQuantity} kleur${offerQuantity === 6 ? 'en' : ''} voor je gratis ${offerQuantity === 6 ? 'STRWKY’s' : 'STRWKY'}, of ga verder met ${selectedQuantity} ${selectedQuantity === 1 ? 'stuk' : 'stuks'}.`;
          addButton.textContent = `Verder met ${selectedQuantity} ${selectedQuantity === 1 ? 'stuk' : 'stuks'}`;
          return;
        }
        addButton.disabled = true;
        addButton.textContent = root.dataset.addingLabel;
        if (statusNode) statusNode.textContent = '';

        try {
          const routeRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${routeRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || root.dataset.errorLabel);

          try {
            const cartResponse = await fetch(`${routeRoot}cart.js`, { headers: { Accept: 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.dispatchEvent(new CustomEvent('strwky:cart-added', { detail: { cart: cart, strwky: strwkyCart(cart) } }));
            }
          } catch (_) {}

          window.location.assign(`${routeRoot}cart`);
        } catch (error) {
          if (statusNode) statusNode.textContent = error.message || root.dataset.errorLabel;
          updateOrder();
        }
      });

      updateStory();
      updateOrder();
      loadCartProgress().catch(() => {});
    };

    const initializeAll = (scope = document) => {
      if (scope.matches?.('[data-strwky-commerce]')) initializeRoot(scope);
      scope.querySelectorAll?.('[data-strwky-commerce]').forEach(initializeRoot);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches?.('[data-strwky-commerce]')
        ? event.target
        : event.target.querySelector?.('[data-strwky-commerce]');
      root?.dispatchEvent(new CustomEvent('strwky:destroy'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
